export default __webpack_public_path__ + "static/media/logo.f25304b7.svg";